<div style="width: 100%; height: 100%">
    <!--    <img [src]="urlImageOK" alt="" style="width: 100%" />-->
    <angular-image-viewer class="img-viewer-h" [src]="urls">
    </angular-image-viewer>
</div>
